import * as MD from '@material-ui/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { withTheme } from '@material-ui/styles';

import Moment from 'moment';

//Store
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N, ILocaleInfos } from '../../Store/I18n/Types';

//Icons
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import MoreIcon from '@material-ui/icons/More';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

// Material components

//Router

import {
  ISearchParams,
  ISearchState,
  ISpotRegroupement,
  IMetadatas,
  IOrderValue,
  EMediaTypes,
  ResultSearch,
  SearchResponse,
} from '../../Store/Search/Types';
import { launchSearch, paginateSearch } from '../../Store/Search/Actions';
import { selectMusic, setSpotDetails } from '../../Store/SpotDetails/Actions';
import { ISpotDetailsState } from '../../Store/SpotDetails/Types';
import {
  StyledLink,
  TableCell,
  TableHeaderCell,
} from '../../Themes/StyledElements';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import { isNullOrUndefined } from '../../Utils/Various';

import { IUserState } from '../../Store/User/Types';
import { PlayerMaster } from '../PlayerMaster';

import styles from './Content.style';
import { Alert, AlertTitle } from '@material-ui/lab';
import { TablePaginationActions } from '../CustomMui/TablePagination';

interface IPropsFromState {
  i18n: I18N;
  search: ISearchState;
  spotDetails: ISpotDetailsState;
  user: IUserState;
  localeInfos: ILocaleInfos;
}

interface IPropsTheme {
  theme: any;
}

interface IPropsFromDispatch {
  launchSearch: typeof launchSearch;
  setSpotDetails: typeof setSpotDetails;
  paginateSearch: typeof paginateSearch;
  selectMusic: typeof selectMusic;
}

type AllProps = WithStyles<typeof styles> &
  IPropsFromState &
  IPropsFromDispatch &
  IPropsTheme &
  IConnectedReduxProps;

interface IState {
  currentPage: number;
  perPage: number;
  totalPages: number;
  totalTrackCount: number;
  isPlayerOpen: boolean;
  filmIdLabel: string;
  currentVideoPlayingSource: string | null;
  metadataPlaying: any;
  selectedItem: IMetadatas | null;
  selectedItemIndex: number;
  hover: boolean;
  playerMasterFilmId: string;
}
class DashboardContentComponent extends React.Component<AllProps, IState> {
  public constructor(props: AllProps) {
    super(props);
    this.state = {
      currentPage: 0,
      perPage: 100,
      totalPages: 0,
      totalTrackCount: 0,
      isPlayerOpen: false,
      currentVideoPlayingSource: null,
      metadataPlaying: null,
      selectedItem: null,
      selectedItemIndex: -1,
      hover: false,
      playerMasterFilmId: '',
      filmIdLabel: '',
    };
  }

  public componentDidMount() {
    if (isNullOrUndefined(this.props.search.searchResults)) {
      let params = this.props.search.params;
      this.props.launchSearch({
        ...params,
      });
    }
  }

  static getDerivedStateFromProps(props: AllProps, state: IState) {
    state.currentPage = props.search.params.params.page - 1;

    return state;
  }

  private onOrderByClick = (fieldValue: string) => {
    const { params } = this.props.search;

    const currentOrderIndex = this.props.search.params.params.order_by
      .map((item) => item.field)
      .indexOf(fieldValue);

    let newOrderList = [...this.props.search.params.params.order_by];

    if (currentOrderIndex > -1) {
      if (newOrderList[currentOrderIndex].value === IOrderValue.DESC) {
        newOrderList = [];
      } else {
        newOrderList[currentOrderIndex].value = IOrderValue.DESC;
      }
    } else {
      newOrderList = [
        {
          field: fieldValue,
          value: IOrderValue.ASC,
        },
      ];
    }

    let searchParams = {
      ...params,
      params: {
        ...params.params,
        order_by: newOrderList,
      },
    };
    this.props.launchSearch(searchParams);
  };

  private drawProviderHeaderColLabel = () => {
    const { media } = this.props.search.params;
    if (media === EMediaTypes.RADIO) {
      return this.props.i18n._('Radio station');
    }
    return this.props.i18n._('channel');
  };

  private drawResultsTableHeaders = () => {
    let headCells: Array<{
      id: number;
      numeric: boolean;
      disablePadding: boolean;
      label: string;
      fieldValue: null | string;
      product: EMediaTypes[];
      isSortable: boolean;
    }> = [];
    headCells = [
      {
        id: 0,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('Vidéo'),
        fieldValue: null,
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: false,
      },
      {
        id: 2,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('Advertiser'),
        fieldValue: 'advertiser',
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: false,
      },
      {
        id: 3,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('Product'),
        fieldValue: 'product',
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: false,
      },
      {
        id: 7,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('duration'),
        fieldValue: 'duration',
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: true,
      },
      {
        id: 4,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('GROUPE'),
        fieldValue: 'group_length',
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: true,
      },
      {
        id: 5,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('Arpp'),
        fieldValue: 'arpp_code',
        product: [EMediaTypes.TV],
        isSortable: true,
      },
      {
        id: 6,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('1ère Diff'),
        fieldValue: 'first_diffusion',
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: true,
      },
      {
        id: 8,
        numeric: false,
        disablePadding: true,
        label: this.drawProviderHeaderColLabel(),
        fieldValue: null,
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: false,
      },
      {
        id: 9,
        numeric: false,
        disablePadding: true,
        label: this.props.i18n._('Details'),
        fieldValue: null,
        product: [EMediaTypes.RADIO, EMediaTypes.TV],
        isSortable: false,
      },
    ];
    return (
      <MD.TableHead>
        <MD.TableRow>
          {headCells
            .filter((v, i) =>
              v.product.includes(this.props.search.params.media)
            )
            .map(
              (
                headCell: {
                  id: number;
                  numeric: boolean;
                  disablePadding: boolean;
                  label: string;
                  fieldValue: null | string;
                  isSortable: boolean;
                },
                index: number
              ) => {
                const { theme } = this.props;
                let currentOrderValue: IOrderValue | null = null;

                if (headCell.fieldValue) {
                  const currentOrderIndex =
                    this.props.search.params.params.order_by
                      .map((item) => item.field)
                      .indexOf(headCell.fieldValue);
                  if (
                    currentOrderIndex > -1 &&
                    this.props.search.params.params.order_by[currentOrderIndex]
                      .field === headCell.fieldValue
                  ) {
                    currentOrderValue =
                      this.props.search.params.params.order_by[
                        currentOrderIndex
                      ].value;
                  }
                }

                return (
                  <TableHeaderCell
                    key={`${headCell.id}`}
                    style={{
                      textTransform: 'uppercase',
                      whiteSpace: 'nowrap',
                    }}
                    align={headCell.numeric ? 'right' : 'left'}
                  >
                    {headCell.label}
                    {headCell.fieldValue !== null && headCell.isSortable ? (
                      <MD.IconButton
                        size="small"
                        onClick={this.onOrderByClick.bind(
                          this,
                          headCell.fieldValue
                        )}
                      >
                        {currentOrderValue === IOrderValue.ASC && (
                          <ArrowDropUpIcon
                            style={{
                              height: '1.375em',
                              width: '1.375em',
                              color: theme.palette.primary.main,
                            }}
                          />
                        )}
                        {currentOrderValue === IOrderValue.DESC && (
                          <ArrowDropDownIcon
                            style={{
                              height: '1.375em',
                              width: '1.375em',
                              color: theme.palette.primary.main,
                            }}
                          />
                        )}
                        {currentOrderValue === null && (
                          <ArrowDropUpIcon
                            style={{
                              height: '1.375em',
                              width: '1.375em',
                              color: theme.palette.text.primary,
                            }}
                          />
                        )}
                      </MD.IconButton>
                    ) : null}
                  </TableHeaderCell>
                );
              }
            )}
        </MD.TableRow>
      </MD.TableHead>
    );
  };

  private displayLabelWithBadge = (headCell: any) => {
    if (headCell.label) {
      return <MD.Grid item>{headCell.label}</MD.Grid>;
    }
    return <MD.Grid item></MD.Grid>;
  };

  private handleShowVideoPlayerClick = (id: string) => {
    this.setState({
      isPlayerOpen: true,
      filmIdLabel: id,
    });
  };

  private drawResultsTableRow = (item: ResultSearch, index: number) => {
    const { classes, theme, localeInfos } = this.props;
    let startDate: Moment.Moment | string = item.first_diffusion || '';
    if (startDate !== null && startDate !== '') {
      let locale: string = 'fr';
      if (localeInfos.momentLocale === 'en-us') {
        locale = 'en-us';
      } else if (localeInfos.momentLocale === 'fr') {
        locale = 'fr';
      } else if (localeInfos.momentLocale === 'de') {
        locale = 'en-us';
      }
      startDate = Moment.utc(startDate)
        .locale(locale)
        .local()
        .format('DD MMM YYYY');
    }
    return (
      <MD.TableRow key={item.id}>
        <TableCell align="center">
          <MD.IconButton
            style={{
              padding: 0,
            }}
            onClick={(event: any) => {
              event.stopPropagation();
              this.handleShowVideoPlayerClick(
                this.props.search.params.media === EMediaTypes.TV
                  ? item.reference_ad_filmid_label
                  : `${item.reference_ad_id}`
              );
            }}
          >
            <PlayCircleFilledIcon
              className={classes.iconStyle}
              color="secondary"
            />
          </MD.IconButton>
        </TableCell>
        <TableCell>{item.advertiser}</TableCell>
        <TableCell>{item.product}</TableCell>
        <TableCell>{item.duration}</TableCell>
        <TableCell>{item.group_length}</TableCell>
        {this.props.search.params.media === EMediaTypes.TV && (
          <TableCell>{item.arpp_code}</TableCell>
        )}
        <TableCell style={{ whiteSpace: 'nowrap' }}>
          {item.no_diffusion ? 'INCONNU' : startDate}
        </TableCell>
        <TableCell>{item.no_diffusion ? 'INCONNU' : item.media}</TableCell>
        <TableCell align="center">
          {item.has_formulaire && (
            <StyledLink
              theme={theme}
              to={
                '/formulaire/' +
                item.id.split('_')[0] +
                '/' +
                item.reference_ad_id +
                '/' +
                this.props.user.userInfo.parent_info.id
              }
              onClick={(event: any) => {
                event.stopPropagation();
              }}
            >
              <MD.IconButton style={{ padding: '2px' }}>
                <InsertDriveFileIcon className={classes.detailsIcon} />
              </MD.IconButton>
            </StyledLink>
          )}
          <StyledLink
            theme={theme}
            to={
              item.id.split('_')[0] === '1'
                ? '/details-television/' +
                  item.id.split('_')[0] +
                  '/' +
                  item.reference_ad_id
                : '/details-radio/' +
                  item.id.split('_')[0] +
                  '/' +
                  item.reference_ad_id
            }
            onClick={(event: any) => {
              event.stopPropagation();
            }}
          >
            <MD.IconButton style={{ padding: '2px' }}>
              <MoreIcon className={classes.detailsIcon} />
            </MD.IconButton>
          </StyledLink>
        </TableCell>
      </MD.TableRow>
    );
  };

  private onChangePageResultsTable = (
    _event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
    page: number
  ) => {
    this.setState({ currentPage: page });
    this.props.paginateSearch(page + 1, this.state.perPage);
  };

  private onChangeRowsPerPageResultsTable = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const perPage = parseInt(event.target.value);
    this.setState({ perPage: perPage, currentPage: 0 });
    this.props.paginateSearch(1, perPage);
  };

  private drawResultsTable = (searchResponse: SearchResponse) => {
    const { i18n, theme } = this.props;
    const { results, total_count, total_pages } = searchResponse;

    return (
      <MD.Grid item xs={12}>
        <MD.Paper>
          <MD.TableContainer
            style={{ maxHeight: 'calc(100vh - 50px - 8px - 52px - 8px)' }}
          >
            <MD.Table
              stickyHeader
              aria-labelledby="tableTitle"
              size="small"
              aria-label="search table"
            >
              {this.drawResultsTableHeaders()}
              <MD.TableBody>
                {results.map((item: ResultSearch, index: number) => {
                  return this.drawResultsTableRow(item, index);
                })}
              </MD.TableBody>
            </MD.Table>
          </MD.TableContainer>
          <MD.TablePagination
            component="div"
            labelRowsPerPage={
              <MD.Typography
                variant="caption"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: theme.palette.text.primary,
                  flexDirection: 'row',
                  flexFlow: 'row nowrap',
                  flexShrink: 0,
                }}
              >
                {i18n._('Rows per page')}
              </MD.Typography>
            }
            rowsPerPageOptions={[5, 10, 25, 50, 100, 1000]}
            count={total_count}
            rowsPerPage={this.props.search.params.params.page_size}
            page={this.state.currentPage}
            onPageChange={this.onChangePageResultsTable}
            onRowsPerPageChange={this.onChangeRowsPerPageResultsTable}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            labelDisplayedRows={({ from, to, count }) => (
              <MD.Typography
                variant="caption"
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  color: theme.palette.text.primary,
                  flexDirection: 'row',
                  flexFlow: 'row nowrap',
                  flexShrink: 0,
                }}
              >
                {`${i18n._('Showing')} ${from} ${i18n._('to')} ${to} ${i18n._(
                  'of'
                )} ${count} ${i18n._('spots')}`}
              </MD.Typography>
            )}
            ActionsComponent={(subProps: any) => (
              <TablePaginationActions
                {...subProps}
                theme={theme}
                i18n={i18n}
                totalPages={total_pages}
              />
            )}
          />
        </MD.Paper>
      </MD.Grid>
    );
  };

  private drawResultsTableWrapper = () => {
    if (this.props.search.isLoading) {
      if (this.props.search.oldSearchResults) {
        return (
          <>
            <MD.LinearProgress style={{ width: '100%' }} />
            {this.drawResultsTable(this.props.search.oldSearchResults)}
          </>
        );
      } else {
        return <></>;
      }
    }
    if (this.props.search.searchError !== '') {
      return (
        <Alert
          severity="error"
          style={{ height: 'fit-content', width: '100%' }}
        >
          <AlertTitle>Error</AlertTitle>
          {this.props.search.searchError}
        </Alert>
      );
    }
    if (this.props.search.searchResults) {
      return this.drawResultsTable(this.props.search.searchResults);
    }
  };

  private PlayerDialog = () => {
    if (this.state.filmIdLabel === '') {
      return <></>;
    }

    return (
      <MD.Dialog
        fullWidth
        open={this.state.isPlayerOpen}
        onClose={() =>
          this.setState({
            isPlayerOpen: false,
            filmIdLabel: '',
          })
        }
      >
        <MD.DialogContent>
          <PlayerMaster
            autoplay={false}
            isVideo={this.props.search.params.media === EMediaTypes.TV}
            url={`https://streamer.yacast.fr/v0/public/s3?fileType=${
              this.props.search.params.media === EMediaTypes.TV
                ? 'arpp'
                : 'kantar'
            }&fileId=${this.state.filmIdLabel}`}
          />
        </MD.DialogContent>
      </MD.Dialog>
    );
  };

  public render(): React.ReactNode {
    return (
      <>
        {this.PlayerDialog()}
        {this.drawResultsTableWrapper()}
      </>
    );
  }
}

const mapStateToProps = ({
  i18n,
  search,
  spotDetails,
  user,
}: IApplicationState) => ({
  i18n: i18n.i18n,
  search,
  spotDetails,
  user,
  localeInfos: i18n.localeInfos,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  launchSearch: (searchParams: ISearchParams) =>
    dispatch(launchSearch(searchParams)),
  paginateSearch: (page: number, limit: number) =>
    dispatch(paginateSearch(page, limit)),
  setSpotDetails: (
    details: ISpotRegroupement,
    startDate: string,
    endDate: string
  ) => dispatch(setSpotDetails(details, startDate, endDate)),
  selectMusic: (id: string | null) => dispatch(selectMusic(id)),
});

export const DashboardContent = connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(withStyles(styles)(DashboardContentComponent)));
